var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type==='link')?_c('a',{attrs:{"id":_vm.id,"title":_vm.title},on:{"click":_vm.click}},[_c('span',[_vm._t("default")],2)]):_c('button',{attrs:{"id":_vm.id,"title":_vm.title},on:{"click":_vm.click}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }